<h6>
    <div class="float-right">
        <kendo-dropdownlist class="float-right mr-1 k-dropdown" style="width:140px" [data]="taskFilters"
            [textField]="'text'" [valueField]="'value'" value="{{selectedTaskFilter}}" [valuePrimitive]="true"
            (valueChange)="taskFilterSelected($event)">
        </kendo-dropdownlist>
    </div>
</h6>
<div style="padding-top:40px;">
    <kendo-grid [data]="taskGridView" [loading]="tasksloading"
        [pageable]="totalTasks > taskState.take ? { buttonCount: 5, pageSizes: pageSizes } : false"
        [pageSize]="taskState.take" [skip]="taskState.skip" [sortable]="true" [sort]="taskState.sort" [sortable]="true"
        [filterable]="false" [resizable]="true" (dataStateChange)="taskDataStateChange($event)"
        [selectable]="{ mode: 'single' }" [kendoGridSelectBy]="" class="mb-2 mt-2 w-100">
        <kendo-grid-messages noRecords="{{ 'NO-TASKS' | translate }}">
        </kendo-grid-messages>
        <kendo-grid-column field="name" title="{{ 'TASK' | translate }}" [width]="90">
            <ng-template kendoGridCellTemplate let-dataItem>
                <div *ngxPermissionsOnly="['ROLE_OPERATOR']">
                    <a class="pointer emphasizedLabel" (click)="openTask(dataItem)">
                        {{ dataItem.name }}
                    </a>
                </div>
                <div *ngxPermissionsOnly="['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD']">
                    <div [ngSwitch]="isChannelAccessAllowed(dataItem)">
                        <div *ngSwitchCase="true">
                            <a class="pointer emphasizedLabel" (click)="openTask(dataItem)">
                                {{ dataItem.name }}
                            </a>
                        </div>
                        <div *ngSwitchCase="false">
                            <span>{{ dataItem.name }}</span>
                        </div>
                    </div>
                </div>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="assigneeName" title="{{'ASSIGNED-TO' | translate}}" [width]="60">
            <ng-template kendoGridCellTemplate let-dataItem>
                <div *ngxPermissionsOnly="['ROLE_OPERATOR']">
                    {{dataItem.assigneeName}}
                    <a *ngIf="dataItem.status === 'Open'" class="pointer float-right" title="{{'REASSIGN' | translate}}"
                        (click)="openTaskAssigneeDialog(dataItem)">
                        <i class="fas fa-undo icon-info"></i>
                    </a>
                </div>
                <div *ngxPermissionsOnly="['ROLE_PROGRAM_LEAD']">
                    <div [ngSwitch]="dataItem.status === 'Open' && isChannelAccessAllowed(dataItem)">
                        <div *ngSwitchCase="true">
                            {{dataItem.assigneeName}}
                            <a class="pointer float-right" title="{{'REASSIGN' | translate}}"
                                (click)="openTaskAssigneeDialog(dataItem)">
                                <i class="fas fa-undo icon-info"></i>
                            </a>
                        </div>
                        <div *ngSwitchCase="false">
                            {{dataItem.assigneeName}}
                        </div>
                    </div>
                </div>
                <div *ngxPermissionsOnly="['ROLE_CARE_COORDINATOR']">
                    {{dataItem.assigneeName}}
                </div>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="openedOn" title="{{ 'OPENED-ON' | translate }}" [width]="70" filter="date"
            format="{0:d}">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span>{{intl.formatDate(intl.parseDate(dataItem.openedOn), "g")}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="dueDate" title="{{ 'DUE-DATE' | translate }}" filter="date" format="{0:d}"
            [width]="50">
            <ng-template kendoGridCellTemplate let-dataItem>
                <div *ngxPermissionsOnly="['ROLE_OPERATOR']">
                    <span *ngIf="dataItem.dueDate!==null">{{ intl.formatDate(intl.parseDate(dataItem.dueDate), "d")
                        }}</span>
                    <a *ngIf="dataItem.status === 'Open'" class="pointer float-right" title="{{'EDIT' | translate}}"
                        (click)="openTaskDuedateDialog(dataItem)">
                        <i class="fas fa-undo icon-info"></i>
                    </a>
                </div>
                <div *ngxPermissionsOnly="['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD']">
                    <span *ngIf="dataItem.dueDate!==null">{{ intl.formatDate(intl.parseDate(dataItem.dueDate), "d")
                        }}</span>
                    <a *ngIf="dataItem.status === 'Open' && isChannelAccessAllowed(dataItem)"
                        class="pointer float-right" title="{{'EDIT' | translate}}"
                        (click)="openTaskDuedateDialog(dataItem)">
                        <i class="fas fa-undo icon-info"></i>
                    </a>
                </div>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="closedOn" title="{{'STATUS' | translate}}" [width]="60"
            [hidden]="selectedTaskFilter !== 'ALL'">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span>{{dataItem.status | uppercase | translate}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="closedOn" title="{{ 'CLOSED-ON' | translate }}" [width]="70" filter="date"
            format="{0:d}" [hidden]="selectedTaskFilter === 'OPEN'">
        </kendo-grid-column>
        <kendo-grid-column class="text-center" field="eventType" [width]="40" title="{{'EVENT-TYPE'|translate}}"
            [columnMenu]="false" [filterable]="false" [sortable]="false">
            <ng-template kendoGridCellTemplate let-dataItem>
                <div *ngxPermissionsOnly="['ROLE_OPERATOR']">
                    <i title="{{dataItem.eventTypeText}} - {{dataItem.event}}" *ngIf="dataItem.eventType"
                        [className]="dataItem.eventTypeIcon"></i>
                </div>
                <div *ngxPermissionsOnly="['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD']">
                    <div [ngSwitch]="isChannelAccessAllowed(dataItem)">
                        <div *ngSwitchCase="true">
                            <i title="{{dataItem.eventTypeText}} - {{dataItem.event}}" *ngIf="dataItem.eventType"
                                [className]="dataItem.eventTypeIcon"></i>
                        </div>
                    </div>
                </div>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="priority" title="{{'PRIORITY' | translate}}" [width]="50" class="text-center">
            <ng-template kendoGridCellTemplate let-dataItem>
                <div [ngClass]="[dataItem.priorityBadgeClass]"
                    [ngStyle]="{'margin-right': dataItem.status !== 'Open' ? '15px' : ''}">
                    {{dataItem.priority.charAt(0)}}</div>
                <div class="change-icon">
                    <div *ngxPermissionsOnly="['ROLE_OPERATOR']">
                        <a *ngIf="dataItem.status === 'Open'" class="pointer float-right" title="{{'EDIT' | translate}}"
                            (click)="openTaskPriorityDialog(dataItem);">
                            <i class="fas fa-undo icon-info"></i>
                        </a>
                    </div>
                    <div *ngxPermissionsOnly="['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD']">
                        <div [ngSwitch]="dataItem.status === 'Open' && isChannelAccessAllowed(dataItem)">
                            <div *ngSwitchCase="true">
                                <a class="pointer float-right" title="{{'EDIT' | translate}}"
                                    (click)="openTaskPriorityDialog(dataItem);">
                                    <i class="fas fa-undo icon-info"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
    <button id="expandBtn" kendoButton [primary]="true" type="button" (click)="initiateTask(currentUserId)"
        class="mt-2 mb-2 mr-1 float-right">
        {{'ADD-TASK' | translate}}<i class="far fa-plus"></i>
    </button>
</div>

<!-- Task detail dialog -->
<div class="k-overlay" *ngIf="taskOpened"></div>
<kendo-window id="task-detail" [width]="1300" [height]="590" *ngIf="taskOpened" (close)="closeTaskDialog()"
    style="position:fixed" [top]="60" [state]="windowState">
    <kendo-window-titlebar>
        <div class="k-window-title">
            <h3 class="ellipsis-text">{{selectedTask.name}}</h3>
        </div>
        <button kendoWindowMaximizeAction></button>
        <button kendoWindowRestoreAction></button>
        <button kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <app-task-detail [task]="selectedTask" (completed)="onTaskCompleted()"
        (followUpTaskAddedEvent)="followUpTaskAdded()" [isDialog]="true">
    </app-task-detail>
    <kendo-dialog-actions style="position:absolute;margin-left:-16px" class="w-100 mt-3">
        <button kendoButton [primary]="true" type="button" (click)="closeTaskDialog()">
            {{ 'CLOSE' | translate}}</button>
    </kendo-dialog-actions>
</kendo-window>

<!-- task form dialog -->
<app-task-add [dialogOpened]="taskDialogOpened" [memberId]="currentMemberId" [assigneeId]="assigneeId"
    [allowAssigneeOverride]="true" (cancelling)="taskDialogOpened=false;" (save)="afterTaskAdded()">
</app-task-add>

<!-- task assignment dialog -->
<app-task-assign [task]="task" [dialogOpened]="assigneeDialogOpened" (closing)="closeTaskAssigneeDialog();"
    (save)="updateTaskAssignee($event)">
</app-task-assign>

<!-- duedate task dialog -->
<app-task-duedate [task]="task" [dialogOpened]="taskDueDateOpened" (closing)="closeTaskDueDateDialog()"
    (save)="updateTaskDueDate($event)">
</app-task-duedate>

<!-- priority task dialog -->
<app-task-priority [task]="task" [dialogOpened]="priorityDialogOpened" (closing)="closeTaskPriorityDialog();"
    (save)="updateTaskPriority($event)">
</app-task-priority>